'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { CardCodeField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-code.tsx';
import { CardExpiryField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-expiry.tsx';
import { CreditCardFields } from '@sola/ark-core/molecules/credit-card-fields/credit-card-fields.tsx';
import { CardNameField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-name.tsx';
import { CardNumberField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-number.tsx';
import { CardTypeField } from '@sola/ark-core/molecules/credit-card-fields/credit-card-type.tsx';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.tsx';
import { SupporterCCFieldsEnum } from '@sola/schema/dotcom/supporters/paymentMethods.ts';
export const PaymentCCFields = () => {
  const $ = _c(11);
  const {
    t
  } = useTranslation("my");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CardTypeField name={SupporterCCFieldsEnum.cardType} />;
    t1 = <CardNumberField name={SupporterCCFieldsEnum.cardNumber} required={true} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-row space-between gap-comfy-sm"><CardExpiryField name={SupporterCCFieldsEnum.expirationDate} required={true} validateCurrentMonth={true} /><CardCodeField name={SupporterCCFieldsEnum.cvv} required={true} /></div>;
    t3 = <CardNameField name={SupporterCCFieldsEnum.nameOnCard} required={true} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("payments.methodForm.fieldLabels.cardNickname");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("payments.methodForm.fieldLabels.optional");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <CreditCardFields>{t0}{t1}{t2}{t3}<InputField name={SupporterCCFieldsEnum.nickname} label={t4} hint={t5} /></CreditCardFields>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};